import { useEffect, useState } from 'react';

/**
 * Returns the current timestamp, refreshing every `intervalMs` so
 * "X ago" labels stay live without re-rendering the whole tree.
 *
 * Default 1s is enough for "just now / 30s ago / 1m ago" style
 * labels. Bump to a higher value for slower-updating relative dates.
 */
export function useNow(intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
